"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonTypeEnum = void 0;
var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["PRIMARY"] = "primary";
    ButtonTypeEnum["SECONDARY"] = "secondary";
    ButtonTypeEnum["CLICKED"] = "clicked";
})(ButtonTypeEnum = exports.ButtonTypeEnum || (exports.ButtonTypeEnum = {}));
